import { render } from "./Suscripcion.vue?vue&type=template&id=21c7b7d0&scoped=true"
import script from "./Suscripcion.vue?vue&type=script&lang=js"
export * from "./Suscripcion.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=21c7b7d0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c7b7d0"]])

export default __exports__